import { FC, memo, useCallback, useRef } from 'react';
import { Animated } from 'react-native';

import { LogEventPayload } from '../../../redux/actions/analyticsLog';
import GeneralMobileWebHeader, {
  GeneralHeaderRight,
  HEADER_HEIGHT,
  RenderRight,
} from '../../GeneralMobileWebHeader';
import { SEARCH_BAR_MARGIN_BOTTOM, SEARCH_BAR_MARGIN_TOP } from '../ListHeader';

interface Props {
  animateScrollY: Animated.Value;
  logEvent: (payload: LogEventPayload) => void;
}

const Header: FC<Props> = ({ animateScrollY, logEvent }) => {
  const headerRef = useRef<GeneralMobileWebHeader | null>(null);
  const scrollThreshold =
    HEADER_HEIGHT - SEARCH_BAR_MARGIN_TOP - SEARCH_BAR_MARGIN_BOTTOM;

  const renderRight: RenderRight = useCallback(args => {
    return (
      <GeneralHeaderRight {...args} headerRef={headerRef} location="首頁" />
    );
  }, []);

  return (
    <GeneralMobileWebHeader
      ref={headerRef}
      // use empty string is for Homepage Title
      headerTitle=""
      animateScrollY={animateScrollY}
      logEvent={logEvent}
      renderRight={renderRight}
      animateScrollThreshold={scrollThreshold}
    />
  );
};

export default memo(Header);
